import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token");
  const source = params.get("source"); // 👈 'apk' or null

  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setMsg("");

    if (!token) {
      setError("Invalid or missing reset token.");
      return;
    }

    if (!newPass || !confirmPass) {
      setError("Both fields are required.");
      return;
    }

    if (newPass !== confirmPass) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
        "https://laturelectronics.in/smartagri_api/reset_password.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token: token,
            password: newPass,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        // 🔥 MAIN LOGIC DIFFERENCE
        if (source === "apk") {
          setMsg(
            "Password reset successful.\nPlease open the Smart Agri App and login."
          );
        } else {
          setMsg("Password reset successful. Redirecting to login...");
          setTimeout(() => navigate("/"), 2500);
        }
      } else {
        setError(data.message || "Failed to reset password.");
      }
    } catch (err) {
      console.error(err);
      setError("Server error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <img src="/logo.png" alt="logo" style={styles.logo} />

        <h2 style={styles.title}>Reset Password</h2>

        <form onSubmit={handleReset} style={styles.form}>
          <div style={{ position: "relative" }}>
            <input
              type={showNew ? "text" : "password"}
              placeholder="New Password"
              style={styles.input}
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
            />
            <span
              style={styles.showHide}
              onClick={() => setShowNew(!showNew)}
            >
              {showNew ? "Hide" : "Show"}
            </span>
          </div>

          <div style={{ position: "relative" }}>
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm New Password"
              style={styles.input}
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />
            <span
              style={styles.showHide}
              onClick={() => setShowConfirm(!showConfirm)}
            >
              {showConfirm ? "Hide" : "Show"}
            </span>
          </div>

          {error && <p style={styles.error}>{error}</p>}
          {msg && <p style={styles.success}>{msg}</p>}

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

/* ---------------- STYLES ---------------- */

const styles = {
  bg: {
    width: "100%",
    height: "100vh",
    backgroundImage: "url('/bg1.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  card: {
    width: "360px",
    background: "rgba(0, 0, 0, 0.55)",
    backdropFilter: "blur(8px)",
    padding: "30px",
    borderRadius: "15px",
    textAlign: "center",
    boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
    border: "1px solid rgba(255,255,255,0.2)",
  },

  logo: {
    width: "80px",
    marginBottom: "10px",
  },

  title: {
    marginBottom: "20px",
    fontSize: "26px",
    fontWeight: "bold",
    color: "#fff",
  },

  form: {
    display: "flex",
    flexDirection: "column",
  },

  input: {
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "none",
    fontSize: "16px",
    background: "rgba(255,255,255,0.9)",
    width: "100%",
  },

  showHide: {
    position: "absolute",
    right: "12px",
    top: "13px",
    cursor: "pointer",
    fontWeight: "600",
    color: "#007bff",
    fontSize: "14px",
  },

  button: {
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#00c853",
    color: "white",
    fontSize: "18px",
    cursor: "pointer",
  },

  error: {
    color: "red",
    marginBottom: "10px",
  },

  success: {
    color: "lightgreen",
    marginBottom: "10px",
    whiteSpace: "pre-line", // 👈 allows line break in APK message
  },
};

export default ResetPassword;
